import { OrgNotificationProviderAction, OrgNotificationProviderState } from './types'

export function orgNotificationsProviderReducer(
    state: OrgNotificationProviderState,
    action: OrgNotificationProviderAction,
): OrgNotificationProviderState {
    const next = { ...state }

    switch (action.type) {
        case 'loading:set': {
            next.loading = action.loading
            break
        }

        case 'notification:set': {
            next.notification = action.notification
            break
        }
    }

    return next
}
